import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const DefaultPage = lazy(() => import("./default"));
const StructurePartnerDashboard = lazy(() => import("./dashboard"));
const StructurePartnerCreation = lazy(() => import("./create"));
const StructurePartnerDetails = lazy(() => import("./details"));
const ErrorPage = lazy(() => import("@root/error"));

export const structurePartnersRoutes: RouteObject[] = [
  {
    path: "/partners/structure/default",
    element: <DefaultPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/partners/structure/dashboard",
    element: <StructurePartnerDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/partners/structure/create",
    element: <StructurePartnerCreation />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/partners/structure/:structurePartnerId",
    element: <StructurePartnerDetails />,
    errorElement: <ErrorPage />,
  },
];
